import { render } from "./ProteinGraphPsoriasis.vue?vue&type=template&id=12efd79e"
import script from "./ProteinGraphPsoriasis.vue?vue&type=script&lang=js"
export * from "./ProteinGraphPsoriasis.vue?vue&type=script&lang=js"

import "./ProteinGraphPsoriasis.vue?vue&type=style&index=0&id=12efd79e&lang=css"

import exportComponent from "/home/mihai/repos/skinscience/skinatlas/src/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__